import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { RecentSearchesFacade } from '@recent-searches/store/recent-searches.facade';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { RecentSearchesPipe } from '@recent-searches/pipes/searches.pipe';
import { MobileDeviceService } from '@app/services/mobile-device.service';
import { TriggerAmplitudeService } from '@amplitude/services/trigger-amplitude.service';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';
import { ButtonLinkType } from '@design-system/components/molecules/button-link/entities/button-link.types';

@Component({
  selector: 'app-recent-searches',
  templateUrl: './recent-searches.container.html',
  styleUrls: ['./recent-searches.container.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RecentSearchesContainer {
  @Input() index: number;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  public readonly buttonLinkType = ButtonLinkType.Secondary;
  
  constructor(
    private readonly facade: RecentSearchesFacade,
    private readonly recentSearchesPipe: RecentSearchesPipe,
    private readonly mobileDeviceService: MobileDeviceService,
    private readonly triggerAmplitudeService: TriggerAmplitudeService,
  ) { }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  get recentSearches$(): Observable<RecentSearchModel[]> {
    return this.facade.recentSearches$.pipe(
      switchMap(searches => this.recentSearchesPipe.transform(searches))
    );
  }

  get hasRecentSearches$(): Observable<boolean> {
    return this.recentSearches$.pipe(map(recentSearches => !!recentSearches?.length));
  }

  public deleteSearches(): void {
    this.facade.deleteRecentSearches();
  }
}
